<app-graph [data]="graphData()" [options]="barChartOptions" type="bar" [plugins]="barChartPlugins" />
